import store from '@/store';
import { valueType } from '../constants';
export const formatDecimal = (value, options) => {
    const DEFAULT_LANGUAGE = {
        locale: 'pt-BR',
    };
    const { locale } = store.getters?.currency || DEFAULT_LANGUAGE;
    const decimalValue = value ? +Number(typeof value === 'string' ? value.replace(',', '.') : value) : 0;
    const formatting = {
        style: valueType.decimal,
        maximumFractionDigits: options ? options : 0,
    };
    const result = new Intl.NumberFormat(locale, formatting).format(decimalValue);
    return result;
};
